import { Injectable } from '@angular/core';
import * as Parse from 'parse';
import {PARSE_APP_ID, PARSE_MASTER_KEY, PARSE_SERVER_URL, production} from "../util/constants";


@Injectable()
export class CabecalhoService {

  parseAppId = PARSE_APP_ID;
  serverURL = PARSE_SERVER_URL;
  masterKey = PARSE_MASTER_KEY;

  constructor() { }

  init() {
    if (!production) {
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-application-id': this.parseAppId});
      Parse.CoreManager.set('REQUEST_HEADERS', {'x-parse-master-key': this.masterKey});
    }
    Parse.initialize(this.parseAppId, this.masterKey);
    Parse.serverURL = this.serverURL;
  }

  async get() {
    this.init();
    const Cabecalho = Parse.Object.extend('cabecalho');
    const queryCabecalho = new Parse.Query(Cabecalho);
    // queryCabecalho.equalTo('ativo', true);
    queryCabecalho.include('titulo');
    queryCabecalho.include('links');
    const results = await queryCabecalho.find();
    const arrayFinal: Array<any> = [];
    if (results.length > 0) {
      for (let i = 0; i < results.length; i ++) {
        const cabecalho = JSON.parse(JSON.stringify(results[i]));
        const queryLinks = results[i].get('links').query();
        queryLinks.ascending('ordem');
        const links = await queryLinks.find();
        const queryTitulo = results[i].get('titulo').query();
        const titulo = await queryTitulo.find();
        cabecalho.links = JSON.parse(JSON.stringify(links));
        cabecalho.titulo = JSON.parse(JSON.stringify(titulo[0]));
        arrayFinal.push(cabecalho);
      }
    }
    return JSON.parse(JSON.stringify(arrayFinal))[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/cabecalho.service.ts